import React from "react";
import loader from "../../images/loader.gif";

const Loader = () => {
  return (
    <div className="loaderIndicator">
      <img src={loader} alt="" />
    </div>
  );
};

export default Loader;
